import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Dashboard } from './pages/Dashboard';
import Chat from './pages/Chat';
import { LandingPage } from './pages/LandingPage';
import { RoleSelectionPage } from './pages/RoleSelectionPage';
import { Register } from './pages/Register';
import { PrivacySetup } from "@/pages/PrivacySetup";
import { Login } from './pages/Login';
import { Feed } from './pages/Feed';
import { VerificationMethod } from './pages/VerificationMethod';
import { SchoolEmail } from './pages/verification/SchoolEmail';
import { VerifyCode } from './pages/verification/VerifyCode';
import { VerificationSuccess } from './pages/verification/Success';
import { ProfilePhotosPage } from './pages/profile/Photos';
import { ProfileBioPage } from './pages/profile/Bio';
import { ProfileLifestylePage } from './pages/profile/Lifestyle';
import { ProfilePreviewPage } from './pages/profile/Preview';
import PrivacySettingsPage from './pages/settings/Privacy';
import ProfileEditPage from './pages/settings/ProfileEdit';
import { ModelTestPage } from './pages/debug/ModelTest';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { OnboardingGuard } from './components/auth/OnboardingGuard';
import { Toaster } from './components/ui/toaster';
import { PhotoUpload } from './components/profile/PhotoUpload';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/test-upload" element={
            <div className="p-8 bg-brand-background min-h-screen">
              <h1 className="text-2xl text-white mb-6">Photo Upload Test</h1>
              <PhotoUpload />
            </div>
          } />
          <Route path="/role-selection" element={<RoleSelectionPage />} />
          <Route path="/register/*" element={<Register />} />
          <Route path="/login/*" element={<Login />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <OnboardingGuard>
                  <Dashboard />
                </OnboardingGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/feed"
            element={
              <ProtectedRoute>
                <OnboardingGuard>
                  <Feed />
                </OnboardingGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat/:matchId"
            element={
              <ProtectedRoute>
                <OnboardingGuard>
                  <Chat />
                </OnboardingGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/verification-method"
            element={
              <ProtectedRoute>
                <VerificationMethod />
              </ProtectedRoute>
            }
          />
          <Route
            path="/verification/school-email"
            element={
              <ProtectedRoute>
                <SchoolEmail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/verification/school-email/verify"
            element={
              <ProtectedRoute>
                <VerifyCode />
              </ProtectedRoute>
            }
          />
          <Route
            path="/verification/success"
            element={
              <ProtectedRoute>
                <VerificationSuccess />
              </ProtectedRoute>
            }
          />
          <Route
            path="/privacy-setup"
            element={
              <ProtectedRoute>
                <PrivacySetup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/photos"
            element={
              <ProtectedRoute>
                <ProfilePhotosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/bio"
            element={
              <ProtectedRoute>
                <ProfileBioPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/lifestyle"
            element={
              <ProtectedRoute>
                <ProfileLifestylePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/preview"
            element={
              <ProtectedRoute>
                <ProfilePreviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <OnboardingGuard>
                  <PrivacySettingsPage />
                </OnboardingGuard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/profile"
            element={
              <ProtectedRoute>
                <OnboardingGuard>
                  <ProfileEditPage />
                </OnboardingGuard>
              </ProtectedRoute>
            }
          />

          {/* Debug route - accessible without authentication */}
          <Route path="/debug/model-test" element={<ModelTestPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
